import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { REPORTS } from "~/components/cesiumComponents/constants";


interface MainViewState {
  componentName: 'bridgeForm' | typeof REPORTS | null;
  // selectedTab: string;
  showOverlay: boolean;
};

const initialState: MainViewState = {
    componentName: null,
    // selectedTab: "",
    showOverlay: true,
};

const mainViewSlice = createSlice({
  name: "mainView",
  initialState,
  reducers: {
    // setComponentName: (state, action: PayloadAction<string | null>) => {
    //   console.log("setComponentName action payload:", action.payload);
    //   if (action.payload) {
    //     state.showOverlay = true; // Hide overlay when component name is set
    //   } else {
    //     state.showOverlay = false; // Show overlay when component name is cleared
    //   }
    //   state.componentName = action.payload;
    // },
    // setSelectedTab: (state, action: PayloadAction<string>) => {
    //   state.selectedTab = action.payload;
    // },
    setShowOverlay: (state, action: PayloadAction<boolean>) => {
      state.showOverlay = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Add extra reducers here
  },
});

export const {  setShowOverlay } = mainViewSlice.actions;
export const selectMainView = (state: any) => state.mainView;
export default mainViewSlice.reducer;